import React, { useState } from 'react';
import Fornecedor from '../fornecedores/Fornecedor';
import MateriaPrima from '../materiaPrima/MateriaPrima';
import Cronoanalise from '../Cronoanalise/Cronoanalise';
import Produto from '../produto/Produto';
import '../App.css';
import '../TelaProduto.css';



const Funcionalidades = () => {
  // Estado para controlar qual formulário está sendo exibido
  const [formularioAtivo, setFormularioAtivo] = useState('');

  // Função genérica para alternar entre formulários
  const abrirFormulario = (formulario) => {
    setFormularioAtivo(formulario);

  };

  return (
    <div>
      <div className="container">
        <div className="botao-container">
          <button
            onClick={() => abrirFormulario('fornecedor')}
            className={`botao-fornecedor ${formularioAtivo === 'fornecedor' ? 'active' : ''}`}>
            Cadastrar Fornecedor
          </button>
          <button
            onClick={() => abrirFormulario('materiaPrima')}
            className={`botao-materia-prima ${formularioAtivo === 'materiaPrima' ? 'active' : ''}`}>
            Cadastrar Matéria-Prima
          </button>
          <button
            onClick={() => abrirFormulario('fichaTecnica')}
            className={`botao-ficha-tecnica ${formularioAtivo === 'fichaTecnica' ? 'active' : ''}`}>
            Cadastrar Ficha Técnica
          </button>
          <button
            onClick={() => abrirFormulario('produto')}
            className={`botao-produto ${formularioAtivo === 'produto' ? 'active' : ''}`}>
            Cadastrar Produto
          </button>
          <button
            onClick={() => abrirFormulario('cronoanalise')}
            className={`botao-cronoanalise ${formularioAtivo === 'cronoanalise' ? 'active' : ''}`}>
            Cronoanálise de Tempos
          </button>
        </div>
        <div>
          {formularioAtivo === 'fornecedor' && <Fornecedor />}
          {formularioAtivo === 'materiaPrima' && <MateriaPrima />}
          {formularioAtivo === 'cronoanalise' && <Cronoanalise />}
          {formularioAtivo === 'produto' && <Produto />}

        </div>
      </div>
    </div>
  );
};

export default Funcionalidades;